import * as actionType from "./actionTypes";
import { postRequest, getRequest, processError } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";
import { saveCheckoutDetails } from "../localStorage";
import _cart from "../cart";
import { hasAllOptions } from "../../utils/generalUtils";

/* =========================== PRODUCTS =========================== */

// The whole catalogue is loaded once when the site opens (managed in the admin)
export const loadProducts = () => (
  (dispatch) => {
    const lsItem = LS_ITEM.PRODUCTS;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequest("/Products",
      (products) => {
        dispatch({ type: actionType.SET_PRODUCTS, products });
        //Drop anything in a saved cart that is no longer for sale (or whose options have changed)
        const bySku = products.reduce((acc, p) => ({ ...acc, [p.sku]: p }), {});
        dispatch(_cart.actions.removeUnavailable((item) => !!bySku[item.sku] && hasAllOptions(bySku[item.sku], item.options)));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

// The delivery fee rules and areas (set on the server), so the cart shows what the checkout will charge
export const loadDeliveryOptions = () => (
  (dispatch) => {
    getRequest("/Shop/DeliveryOptions",
      (delivery) => dispatch({ type: actionType.SET_DELIVERY, delivery }),
      () => { /* The checkout still adds the right fee - the cart just can't show it */ },
    );
  }
);

/* =========================== CHECKOUT =========================== */

// Creates the order on the server and sends the customer to Yoco's secure payment page
export const checkout = (items, details) => (
  (dispatch) => {
    const lsItem = LS_ITEM.CHECKOUT;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    //Remember the details in case they come back from Yoco without paying
    saveCheckoutDetails({ ...details, acceptedTerms: false });

    postRequest("/Shop/CreateCheckout",
      {
        ...details,
        items: items.map((x) => ({ sku: x.sku, options: x.options, quantity: x.quantity })),
      },
      (result) => {
        //Leave the loading state on - the page is navigating away
        window.location.href = result.redirectUrl;
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

/* =========================== ORDER STATUS =========================== */

const setOrderStatus = (order) => (
  {
    type: actionType.SET_ORDER_STATUS,
    order,
  }
);

export const loadOrderStatus = (reference, silent=false) => (
  (dispatch) => {
    const lsItem = LS_ITEM.ORDER_STATUS;
    if (!silent) {
      dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    }

    getRequest(`/Shop/OrderStatus?reference=${encodeURIComponent(reference)}`,
      (order) => {
        dispatch(setOrderStatus(order));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      () => dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.ERROR)),
    );
  }
);

/* =========================== CONTACT =========================== */

export const sendContactMessage = (message, successCB) => (
  (dispatch) => {
    const lsItem = LS_ITEM.CONTACT_SEND;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequest("/Contact/SendContactMessage",
      message,
      () => {
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("Thanks for submitting!", NOTIF_TYPE.SUCCESS));
        successCB();
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);
